module.exports = __webpack_public_path__ + "img/s4Model1.5915e6e5.webp";